'use strict';
import React from 'react';
import * as T from 'prop-types';
import {mapPropsStream} from 'recompose';
import {createFieldState, getErrorValue} from '../utils';
import {DropdownListFieldView} from './DropdownListFieldView';


export const StreamedComponent = (props$) => {
  const {
    onChange,
    state$: baseState$,
  } = createFieldState(props$);

  const state$ = baseState$
    .withLatestFrom(props$)
    .map(([state, props]) => ({
      value: {
        value: state.value,
        label: props.getLabel(state.value),
      },
      error: state.error,
    }));

  return props$
    .combineLatest(
      state$,
      (props, state) => ({
        ...props,
        value: state.value,
        error: getErrorValue(props, state),
        onChange,
      }));
};

export const DropdownListFieldComponent = mapPropsStream(StreamedComponent)(DropdownListFieldView);

DropdownListFieldComponent.propTypes = {
  getLabel: T.func.isRequired,
  onValidate: T.func,
  onChange: T.func,
};



// WEBPACK FOOTER //
// ./src/js/components/forms/DropdownListField/DropdownListFieldComponent.js